import { aiChatApi } from "utilities/Axios";

export const sendAiRequest = (data: { user_message: string; user_id: string; oid: string; sid: string }) => {
  return aiChatApi.post(`/api/v1/chat/`, {
    ...data,
    project_type: "saas",
  });
};

export const getReports = async ({ oid, sid }: { oid: string; sid: string }) => {
  return aiChatApi.get(`/api/v1/report`, {
    params: {
      oid,
      sid,
      project_type: "saas",
    },
  });
};